// extracted by mini-css-extract-plugin
export default {"footer":"DashboardFooterSection_footer__hnFRE","link":"DashboardFooterSection_link__9OvxG"};